/**
 * Pinorion — design palette.
 *
 * Galactic-crossroads theme: deep navy backdrop with constellation
 * lattice, vivid per-page accents (each highway carries its own colour
 * from the brand palette), cream surface for hero affordances.
 */
export const palette = {
  // Hero / shell
  bg: '#0a1850',           // deep navy used as page + canvas clear
  bgDeep: '#061240',       // bottom of background gradient
  bgLight: '#1e3a8a',      // upper of background gradient
  surface: '#0f2068',      // card / panel
  text: '#f8f4ed',         // main on-dark text — slightly warm white
  textSoft: 'rgba(248, 244, 237, 0.78)',
  divider: 'rgba(255, 255, 255, 0.12)',

  // Accents
  blue: '#4a8cff',         // primary brand action
  blueDeep: '#2659d6',     // pressed / dark
  cyan: '#9bc7ff',         // constellation lines / highlights
  cream: '#f8f4ed',        // CTA on dark, pill bg
  creamDim: 'rgba(248, 244, 237, 0.55)',

  // Page accents (kept for per-section theming later)
  purple: '#9b6bff',
  orange: '#ffae5e',
  green: '#5eff9b',
  pink: '#ff5e8a',
} as const;

export type PaletteKey = keyof typeof palette;
